import { useEffect, useState } from 'react';
import { Form, Descriptions, DatePicker, Button, Switch, message } from 'antd';
import moment, { Moment } from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import helper from '../../utils/helper';
import { stepperMoving } from '../../stores/actions';
import { request } from '../../../../shared/src/apis';
import { errorMessage } from '../../utils/commonStringsConsts';
import { getsettleATMRequest } from '../../utils/apisConsts';


export default function ViewAtmCheckoutRequestForm() {
    const [form] = Form.useForm();
    const [date, setDate] = useState<string>('');
    const [switchChecked, setSwitchChecked] = useState<boolean>(false);
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()


    const reqInfo = useSelector((state: any) => {
        let info = state.actionsReducer.info
        delete info.installmentsOrder
        delete info.transactionStatusID
        return info
    })

    useEffect(() => {
        if (reqInfo) {
            setSwitchChecked(!!reqInfo.isSettled);
            setDate(reqInfo.lastSettledAt ? moment(reqInfo.lastSettledAt).format("YYYY-MM-DD") : '');
        }
    }, [reqInfo]);

    const handleDateChange = (date: Moment | null, dateString: string) => {
        setDate(dateString);
        setSwitchChecked(!!dateString);
    };

    const handleSwitchChange = async (checked: boolean) => {
        try {
            await form.validateFields();
            if (checked) {
                setSwitchChecked(true);
            } else {
                setSwitchChecked(false);
            }
        } catch (error) {
            setSwitchChecked(false);
        }
    };
    const handleSettleRequestButton = async () => {
        setLoading(true)
        const settleRes: { [key: string]: any } = await dispatch(request({
            url: `${getsettleATMRequest}`, method: "PATCH",
            data: { advanceID: reqInfo?.advanceID, isSettled: switchChecked, lastSettledAt: date }
        }));
        try {
            if (settleRes?.data?.statusCode === 200) {
                message.success(settleRes?.data?.message)
                dispatch(stepperMoving(0))
            }
            else {
                message.error(settleRes?.data?.message)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            message.error(errorMessage);
        }
    };
    return (
        <Descriptions
            title={`Request#${reqInfo?.advanceID}`}
            bordered
            size="small"
            className='my-6'
            extra={
                <Form
                    layout="inline"
                    onFinish={handleSettleRequestButton}
                    form={form}
                    initialValues={{
                        ...reqInfo,
                        date: reqInfo?.lastSettledAt ? moment(reqInfo?.lastSettledAt) : null,
                        isSettled: reqInfo?.isSettled
                    }}
                >
                    <Form.Item
                        name="date"
                        rules={[{ required: true, message: 'Required' }]}
                        style={{ marginRight: '4rem' }}
                    >
                        <DatePicker
                            style={{ width: '15rem' }}
                            onChange={handleDateChange}
                            disabledDate={(current) => current && current > moment().endOf('day')}
                        />

                    </Form.Item>
                    <Form.Item
                        name="isSettled"
                        style={{ marginRight: '5rem' }}>
                        <div className='flex items-center'>
                            <p className='mb-0 mr-2'>Settle</p>
                            <Switch
                                checked={switchChecked} onChange={handleSwitchChange} />
                        </div>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            className='userBtn' loading={loading} type="primary" shape='round' htmlType="submit"
                            style={{ backgroundColor: "#7CC58F", borderColor: "#7CC58F" }}
                        >
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            }
        >
            {
                Object.keys(reqInfo).filter((key) => key !== "advanceID").map((key, i) => <Descriptions.Item key={`${key}-${i}`} label={helper.unCamelCase(key)} span={2}>{reqInfo[key]}</Descriptions.Item>)
            }
        </Descriptions>
    );
};


